import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const BBIconTemplate = React.forwardRef((props, ref) => (
    <span ref={ref} className={"BBIcon"}>
        <SvgIcon
        component={props.customIcon}
        viewBox="0 0 100 100"
        style={props.style}
        className={props.className}
        />
    </span>
));

export default BBIconTemplate;